import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = ["href"];
const _hoisted_3 = ["href"];
import { useErrorLogStore } from '@/store/modules/errorLog';

import { storeToRefs } from 'pinia';
import { reactive } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const errorLogStore = useErrorLogStore();
    const {
      errorLogs
    } = storeToRefs(errorLogStore);
    const {
      clearErrorLog
    } = errorLogStore;
    const state = reactive({
      dialogVisible: false
    });
    const searchList = [{
      title: '百度搜索',
      url: 'https://www.baidu.com/baidu?wd=',
      icon: 'baidu-line'
    }, {
      title: '谷歌搜索',
      url: 'https://www.google.com/search?q=',
      icon: 'google-line'
    }];
    const clearAll = () => {
      state.dialogVisible = false;
      clearErrorLog();
    };
    return (_ctx, _cache) => {
      const _component_vab_icon = _resolveComponent("vab-icon");
      const _component_el_badge = _resolveComponent("el-badge");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _unref(errorLogs).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_badge, {
        type: "danger",
        value: _unref(errorLogs).length,
        onClick: _cache[0] || (_cache[0] = $event => _unref(state).dialogVisible = true)
      }, {
        default: _withCtx(() => [_createVNode(_component_vab_icon, {
          icon: "bug-line"
        })]),
        _: 1
      }, 8, ["value"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(state).dialogVisible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(state).dialogVisible = $event),
        "append-to-body": "",
        title: "admin-plus 异常捕获(温馨提示：错误必须解决)",
        width: "70%"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => _unref(state).dialogVisible = false)
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("取 消", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "danger",
          onClick: clearAll
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("暂不显示", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_table, {
          border: "",
          data: _unref(errorLogs)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "报错路由"
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("a", {
              href: row.url,
              target: "_blank"
            }, [_createVNode(_component_el_tag, {
              type: "success"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(row.url), 1)]),
              _: 2
            }, 1024)], 8, _hoisted_2)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "错误信息"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_el_tag, {
              type: "danger"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(row.err.message), 1)]),
              _: 2
            }, 1024)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "错误详情",
            width: "120"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_el_popover, {
              placement: "top-start",
              trigger: "hover"
            }, {
              reference: _withCtx(() => [_createVNode(_component_el_button, null, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("查看", -1)]))]),
                _: 1
              })]),
              default: _withCtx(() => [_createTextVNode(_toDisplayString(row.err.stack) + " ", 1)]),
              _: 2
            }, 1024)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "380"
          }, {
            default: _withCtx(({
              row
            }) => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(searchList, (item, index) => {
              return _createElementVNode("a", {
                key: index,
                href: item.url + row.err.message,
                target: "_blank"
              }, [_createVNode(_component_el_button, null, {
                default: _withCtx(() => [_createVNode(_component_vab_icon, {
                  icon: item.icon
                }, null, 8, ["icon"]), _createTextVNode(" " + _toDisplayString(item.title), 1)]),
                _: 2
              }, 1024)], 8, _hoisted_3);
            }), 64))]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])]),
        _: 1
      }, 8, ["modelValue"])])) : _createCommentVNode("", true);
    };
  }
});